import { useState } from 'react';
import { Link } from 'react-router-dom';
import { assetApi } from '../../api/media';

type Row = { name: string; file_url: string };

export function BulkUploadPage() {
  const [rows, setRows] = useState<Row[]>([{ name: '', file_url: '' }]);
  const [result, setResult] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const items = rows.filter((r) => r.name && r.file_url).map((r) => ({ name: r.name, file_url: r.file_url, type: 'image' as const }));
      const res = await assetApi.bulkUpload(items);
      setResult(`Uploaded ${res.count} asset(s).`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Upload failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="mx-auto max-w-3xl p-6">
      <Link to="/media" className="text-sm text-slate-600 hover:underline">← Library</Link>
      <h1 className="mt-4 text-2xl font-semibold">Bulk Upload</h1>
      <form onSubmit={(e) => void submit(e)} className="mt-6 space-y-4">
        {rows.map((row, i) => (
          <div key={i} className="rounded-xl border bg-white p-4 space-y-2">
            <input value={row.name} onChange={(e) => setRows((r) => r.map((x, j) => (j === i ? { ...x, name: e.target.value } : x)))} placeholder="Asset name" className="w-full rounded-lg border px-3 py-2 text-sm" />
            <input value={row.file_url} onChange={(e) => setRows((r) => r.map((x, j) => (j === i ? { ...x, file_url: e.target.value } : x)))} placeholder="File URL" className="w-full rounded-lg border px-3 py-2 text-sm" />
          </div>
        ))}
        <button type="button" onClick={() => setRows((r) => [...r, { name: '', file_url: '' }])} className="text-sm text-slate-700 hover:underline">+ Add row</button>
        <button type="submit" disabled={loading} className="block rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">{loading ? 'Uploading…' : 'Upload all'}</button>
      </form>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {result && <p className="mt-4 text-sm text-green-700">{result}</p>}
    </div>
  );
}
